import { CONTACT } from "@/config/contact";

export default function PrivacyPage() {
  return (
    <div className="pt-28 lg:pt-44 pb-16" data-testid="privacy-page">
      <section className="max-w-3xl mx-auto px-6">
        <p className="font-accent text-xl text-sunset mb-1">your privacy</p>
        <h1 className="font-display text-4xl sm:text-5xl tracking-tight mb-4">Privacy Policy</h1>
        <p className="text-charcoal/50 text-xs mb-8">Please review with a professional before publishing. Last updated: 2026.</p>

        <div className="space-y-6 text-charcoal/75 leading-relaxed text-sm">
          <p>This policy explains how {CONTACT.businessName} looks after your personal information when you use this website, place an order or get in touch.</p>

          <div>
            <h2 className="font-display text-lg text-black mb-2">What I collect</h2>
            <p>When you order or contact me I may collect your name, email address, phone number, delivery address and details of your order or enquiry. If you join the newsletter I keep your email address.</p>
          </div>

          <div>
            <h2 className="font-display text-lg text-black mb-2">How I use it</h2>
            <p>To process and deliver your orders, respond to your enquiries, keep you updated about your order and — only if you've opted in — send occasional news. I don't sell your information to anyone.</p>
          </div>

          <div>
            <h2 className="font-display text-lg text-black mb-2">Who I share it with</h2>
            <p>Trusted providers who help run the shop: <strong>Stripe</strong> (secure payment processing), <strong>Resend</strong> (order and enquiry emails) and my website hosting provider. Each only receives what they need to provide their service.</p>
          </div>

          <div>
            <h2 className="font-display text-lg text-black mb-2">Cookies</h2>
            <p>The site uses essential cookies and your browser's local storage to remember things like your shopping bag. No unnecessary tracking.</p>
          </div>

          <div>
            <h2 className="font-display text-lg text-black mb-2">Keeping your data</h2>
            <p>I keep order records for as long as needed to meet legal and accounting requirements, then delete them. You can ask me to access or delete your information at any time.</p>
          </div>

          <div>
            <h2 className="font-display text-lg text-black mb-2">Your rights</h2>
            <p>Under UK GDPR you can ask for a copy of your data, ask me to correct or delete it, or withdraw consent for marketing. Just email me and I'll sort it out.</p>
          </div>

          <div>
            <h2 className="font-display text-lg text-black mb-2">Contact</h2>
            <p>Questions about your privacy? Email <a href={`mailto:${CONTACT.email}`} className="text-olive underline underline-offset-2">{CONTACT.email}</a>.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
